import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { Divider, Grid, IconButton, Box } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"

import { useHistory, useRouteMatch, useLocation } from "react-router-dom"
import { operationsHelper } from "../../../../helpers/operations"
import Annotations from "../../additionalDetails/Annotations"
import { ANNO_BG_COLOR } from "../../../../utils"

const useStyles = makeStyles((theme) => ({
	root: {
		...theme.typography.body2,
		backgroundColor: theme.palette.common.white,
		borderRadius: "5px",
		padding: "16px 23px",
		whiteSpace: "pre-line",
		maxHeight: "80vh",
		height: "65vh",
		overflow: "auto",
		// "& .mark_element.mark_date": { backgroundColor: theme.palette.grey.D700 },
		// "& .mark_element.mark_concept": { backgroundColor: theme.palette.grey.D900 },
		// "& .mark_element.mark_word": { backgroundColor: theme.palette.grey.D1000 },
		// "& .mark_element.mark_email": { backgroundColor: theme.palette.grey.D800 },

		//TODO: This is the temporary solution and we will get back to it when we have the changes ready from Library
		//https://github.com/react-pdf-viewer/react-pdf-viewer/pull/1625

		"& .mark_element.mark_date": { background: "#ffff00" },
		"& .mark_element.mark_concept": { background: "#ffff00" },
		"& .mark_element.mark_word": { background: "#ffff00" },
		"& .mark_element.mark_email": { background: "#ffff00" },
		"& .ellipses": { overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" },
	},
}))

const PDFViewer = () => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const [currentDocumentContent, setCurrentDocumentContent] = useState("")
	const { currentDocument, documentLoading, documentDetails } = useSelector((state) => state.documentModal)
	const [annotations, setAnnotations] = useState([])
	const build_concept = useSelector((state) => state.buildconcept.highlight_concepts)
	const view_documents = useSelector((state) => state.viewdocuments.currentConceptTargetTerms)
	const search = useSelector((state) => state.search.concept_target_terms)
	const create_timeline = useSelector((state) => state.timeline.concept_target_terms)
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const loadedConcept = useSelector((state) => state.highlightFilter.search.loadedConcept)
	const annotationData = useSelector((state) => state.viewerData.annotations)
	const { path } = useRouteMatch()
	let location = useLocation()
	useEffect(() => {
		if (!_.isEmpty(currentDocument)) {
			setCurrentDocumentContent(currentDocument)
		} else {
			setCurrentDocumentContent(" ")
		}
	}, [currentDocument])

	const maskHightlight = (currentDocumentContent) => {
		let markedText = operationsHelper.cleanHTMLTags(currentDocumentContent)
		if (highlightFilter?.emails) {
			markedText = operationsHelper.highlightEmails(markedText)
		}

		if (highlightFilter?.concepts) {
			markedText = operationsHelper.highlightConcepts(markedText, loadedConcept)
		}

		if (highlightFilter?.dates) {
			markedText = operationsHelper.hightlightDatesInDocument(markedText)
		}

		if (highlightFilter?.specificWord) {
			markedText = operationsHelper.highlightWords(markedText, highlightFilter?.searchWord)
		}

		return { __html: `<div className="mark_element">${markedText}</div>` }
	}

	useEffect(() => {
		if (annotationData) {
			setAnnotations(annotationData)
		}
		console.log(annotationData)
	}, [annotationData])

	return (
		<Box className={classes.root}>
			{!documentLoading ? (
				highlightFilter?.annotation ? (
					<>
						<Annotations id="viewer-container" style={{ ...theme.typography.body2 }} content={currentDocumentContent} />
					</>
				) : (
					<>
						<Typography
							id="viewer-container"
							style={{ ...theme.typography.body2 }}
							dangerouslySetInnerHTML={maskHightlight(currentDocumentContent)}
						/>
					</>
				)
			) : (
				<Skeleton animation="wave" variant="rectangular" height="80vh" />
			)}
		</Box>
	)
}

export default PDFViewer
